var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaFilmcamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.92039C4 4.6332 4.23281 4.40039 4.52 4.40039H10.68C10.7575 4.40039 10.831 4.41734 10.8971 4.44774C11.0539 4.4616 11.2026 4.54613 11.2926 4.68977L12.316 6.32198C12.3319 6.34737 12.3453 6.3736 12.3564 6.40039H13.1538C13.4003 6.40039 13.6 6.60634 13.6 6.86039V9.20039H15.0188L17.332 6.53213C17.4493 6.39678 17.618 6.36242 17.7625 6.44445C17.9069 6.52649 18 6.70953 18 6.91151V15.0893C18 15.2913 17.9069 15.4743 17.7625 15.5563C17.618 15.6384 17.4493 15.604 17.332 15.4687L15.0187 12.8004H13.6V15.1404C13.6 15.3944 13.4003 15.6004 13.1538 15.6004H2.44615C2.19975 15.6004 2 15.3944 2 15.1404V6.86039C2 6.60634 2.19975 6.40039 2.44615 6.40039H11.1366L10.5347 5.44039H4.52C4.23281 5.44039 4 5.20758 4 4.92039ZM15.6 9.90715V12.0938L17.2 13.9393V8.0615L15.6 9.90715ZM14.8 9.92039H13.8857V12.0804H14.8V9.92039ZM2.89231 14.6804V7.32039H12.7077V14.6804H2.89231ZM4.4 8.40039C4.17909 8.40039 4 8.57948 4 8.80039V10.8004C4 11.0213 4.17909 11.2004 4.4 11.2004H10.4C10.6209 11.2004 10.8 11.0213 10.8 10.8004V8.80039C10.8 8.57948 10.6209 8.40039 10.4 8.40039H4.4ZM4.8 10.4004V9.20039H10V10.4004H4.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaFilmcamera);
export default __webpack_public_path__ + "static/media/media-filmcamera.ef76740709ca1d87e5c94e43fd7f3ac9.svg";
export { ForwardRef as ReactComponent };